<template>
    <div id="grouped-items" class="container" :class="{reverse: reverse}">
        <!-- <p class="text-small"><b>Note:</b> Lewis County maintains this list as a courtesy to the public, and does not endorse or guarantee the quality of the services offered or provided.</p>
        <p class="text-small" style="margin-top: 1rem;">If you see an error in any listings, please contact swu@lewiscountywa.gov.</p> -->

        <div class="grouped-items-inner">
        <!-- <div v-if="loading_data">
            <div class="loader"></div>
        </div> -->
        <h4 v-if="total == 0 && (!loading_data)" class="no-results">No items match search</h4>
        <!-- <transition-group name="list-complete" class="row row-wrap item-list" tag="div"> -->
        <div class="item-list hidden">
            <div class="column column-33 subpage-item" v-for="index in limit" :key="index"></div>
        </div>
        <transition-group :name="transitionName" tag="div" class="trans-group" @after-enter="$emit('transitionDone')">
        <!-- <transition-group  enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft" mode="out-in" tag="div" class="trans-group"> -->
            
            <div class="row row-wrap item-list" id="listy" v-for="page in pages_array" v-bind:key='page.id'>
                <!-- <transition-group name="list-complete" class="row row-wrap item-list" tag="div" id="listy"> -->
                <div v-for="gp in grouped_pages" v-bind:key='gp.id' class="column column-33 subpage-item">
                    <div class="subpage-inner rounded-border">
                        <div>
                            <!-- <router-link :to="{ name: gp.id }" tag="a" class="has-color-pink pagination-image" v-if="gp.thumbnail">
                                <img v-if="gp.thumbnail" class="subpage-image" :data-url="gp.thumbnail.url" v-lazyload>
                            </router-link>
                            
                            <router-link :to="{ name: gp.id }" tag="a" class="has-color-pink">
                                <h3>{{ gp.title }}</h3>
                            </router-link> -->
                            <!-- <a v-if="gp.website" v-bind:href="gp.website" target="_blank" rel="noopener noreferrer"><h3>{{ gp.title }}</h3></a>
                            <h3 v-else>{{ gp.title }}</h3> -->
                            <a href="#" v-on:click.prevent="getMoreInfo(gp.id)"><h3>{{ gp.title }}</h3></a>
                        </div> 
                        <p class="has-bold-text">{{ gp.address }}</p>
                        <p>{{ gp.phone_number }}</p>
                        <button v-on:click="getMoreInfo(gp.id)" class="thin" v-if="gp.node_data.length > 0 || gp.address || gp.other_links.length > 0">More info <i class="fas fa-info-circle fa-2x center-vert"></i></button>
                        <!-- <p>{{ gp.relative_price }}</p> -->

                        <!-- <p v-if="gp.website"><a v-bind:href="gp.website" target="_blank">Website</a></p> -->
                        <!-- <p v-for='link in gp.other_links' v-bind:key="link.id"><a v-bind:href="link.url" target="_blank">{{ link.link_text }}</a></p> -->
                    </div>
                </div>
                <!-- </transition-group> -->
            </div>
           
        </transition-group>
        <!-- <div class="pagination bottom">
            <button class="previous-page" @click="previousPage" :disabled='current_page==1'><</button>
            <p>Showing results {{ offset + 1 }} - {{ current_display_ceil }} of {{ total }}</p>
            <button class="next-page" @click="nextPage" :disabled='current_page>=page_count'>></button>
        </div> -->
  
        <!-- <p class="text-small"><b>Note:</b> Lewis County maintains this list as a courtesy to the public, and does not endorse or guarantee the quality of the services offered or provided.</p>
        <p class="text-small">If you see an error in any listings, please contact swu@lewiscountywa.gov.</p> -->
        </div>
        <div class="pagination top">
            <p class="mobile-show">Showing results {{ offset + 1 }} - {{ current_display_ceil }} of {{ total }}</p>
            <button class="previous-page" @click="previousPage" :disabled='current_page<=1' aria-label="Previous Page"><</button>
            <p class="mobile-hide">Showing results {{ offset + 1 }} - {{ current_display_ceil }} of {{ total }}</p>
            <button class="next-page" @click="nextPage" :disabled='current_page>=page_count' aria-label="Next Page">></button>
        </div>
    </div>
</template>

<script>
// Install vue-async-computed and add to main.js
// May require some API filter changes to work properly
// SearchFilter needs altered if useing search and seme field filters
// FieldsFilter needs altered to alow for using the same field multiple times in OR or AND capacity
import LazyLoad from '@/utils/LazyLoad'
import axios from 'axios'
import RelatedItemsVue from './RelatedItems.vue'
import { v4 as uuidv4 } from 'uuid';
export default {
    name: 'Pagination',
    directives: {
        lazyload: LazyLoad
    },
    data() {
        return {
            current_page: 1,
            reverse: false,
            loading_data: false,
            fields_data: this.fields,
            last_results: {id: '', items: []},
            extraData: {
                name: '',
                address: '',
                phone_number: '',
                nodes: []
            }
        }
    },
    props: {
        fields: {
            type: Array,
            default: new Array()
        },
        filters: {
            type: Array
        },
        search: {
            type: String,
            default: ''
        },
        pageType: {
            required: true,
            type: String
        },
        limit: {
            type: Number,
            default: 20,
        },
        order: {
            type: String,
            default: ''
        },
        dates: {
            default: null
        },
        group_by_nodes: {
            type: Boolean,
            default: false
        },
        slideIsOpen: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        transitionName: function() {
            if (!this.slideIsOpen) {
                return "some-name"
            }
            return "slide-josh"
        }, 
        page_count: function() {
            return Math.ceil(this.total/this.limit);
        },
        current_display_ceil: function() {
            let ceil = this.offset + this.limit;
            if (ceil > this.total) {
                return this.total;
            }
            return ceil;
        },
        offset: function() {
            return this.limit*(this.current_page-1);
        },
        query_page_type: function() {
            return '?type=' + this.pageType
        },
        query_child_of: function() {
            if (this.group_by_nodes) {
                return "";
            }
            return '&child_of=' + this.$route.meta.id;
        },
        query_offset: function() {
            return '&offset=' + this.offset;
        },
        query_limit: function() {
            return '&limit=' + this.limit;
        },
        query_fields: function() {
            if (this.fields_data.length > 0) {
                let fieldQuery = '&fields=';
                for (let field in this.fields_data) {
                    fieldQuery += this.fields_data[field]+',';
                }
                fieldQuery = fieldQuery.slice(0, -1);
                return fieldQuery;
            }
            return '';
        },
        query_search: function() {
            let searchQury = '';
            if (this.search.length > 1) {
                let searchString = this.search.replace(' ', '+');
                searchQury = '&search=' + searchString + '&search_operator=or';
            }
            return searchQury;
        },
        query_filters: function() {
            let filterQuery = '';
            if (this.filters.length > 0) {
                filterQuery = '&node='
                for (let filter in this.filters) {
                    filterQuery = filterQuery + this.filters[filter].name.trim() + ','
                }
                filterQuery = filterQuery.slice(0 , -1)
            }
            //// for (let filter in this.filters) {
            ////     filterQuery += '&'+ this.filters[filter].type +'=' + this.filters[filter].value;
            //// }
            // let filterGroups = {};
            // for (let filter in this.filters) {
            //     console.log('filterGroup: ', this.filters[filter].orGroup);
            //     if (filterGroups.hasOwnProperty(this.filters[filter].type)) {
            //         filterGroups[this.filters[filter].type].push({'value': this.filters[filter].value, 'orGroup': (this.filters[filter].orGroup !== undefined) ? this.filters[filter].orGroup : -1});
            //         filterGroups[this.filters[filter].type].sort(function (a,b) {
            //             return a.orGroup - b.orGroup;
            //         })
            //     } else {
            //         filterGroups[this.filters[filter].type] = [];
            //         filterGroups[this.filters[filter].type].push({'value': this.filters[filter].value, 'orGroup': (this.filters[filter].orGroup !== undefined) ? this.filters[filter].orGroup : -1});
            //     }
            // }
            //// console.log('!! This is the filterGroups: ', filterGroups);
            // let groupTracker = 'start';
            // for (var group in filterGroups) {
            //     filterQuery += '&' + group + '=';
            //     for (var i in filterGroups[group]) {
            //         if (filterGroups[group][i].orGroup == groupTracker && groupTracker !== null){
            //             filterQuery += filterGroups[group][i].value + ','
            //         } else {
            //             if (groupTracker == 'start') {
            //                 filterQuery += filterGroups[group][i].value + ',';
            //             } else {
            //                 filterQuery += '_' + filterGroups[group][i].value + ',';
            //             }
            //             groupTracker = filterGroups[group][i].orGroup;
            //         }
            //     }
            //     filterQuery = filterQuery.slice(0, -1);
            // }
            //// console.log('¡¡ This is the filterQuery: ', filterQuery);
            return filterQuery;
        },
        query_order: function() {
            if (this.order.length > 0) {
                return '&order=' + this.order;
            }
            return this.order;
        },
        query_dates: function() {
            let dateStr = "";
            if (this.dates) {
                if (this.dates.startDateFilter && this.dates.endDateFilter) {
                    dateStr += "&dates=";
                    if (this.dates.startDateFilter.length > 0) {
                        dateStr += this.dates.startDateFilter + ',';
                    } else {
                        dateStr += '_,';
                    }
                    if (this.dates.endDateFilter.length > 0) {
                        dateStr += this.dates.endDateFilter;
                    } else {
                        dateStr += '_';
                    }
                    return dateStr;
                }
            }
            return dateStr;
        },
        // queryGroupByNode: function() {
        //     let query = "";
        //     if (this.group_by_nodes.length > 0) {
        //         query = '&gbnodes=' + this.group_by_nodes;
        //     }
        //     return query;
        // },
        data_url: function() {
            return '/api/v2/pages/' + this.query_page_type + this.query_child_of + this.query_offset + this.query_limit + this.query_search + this.query_fields + this.query_filters + this.query_dates + this.query_order;
        },
        grouped_pages: function() {
            return this.grouped_pages_total.items;
        },
        pages_array: function() {
            let pageID = uuidv4()
            if (this.arraysEqual(this.last_results.items, this.grouped_pages_total.items)) {
                pageID = this.last_results.id
            }
            this.last_results.id = pageID
            this.last_results.items = this.grouped_pages_total.items
            return [{id: pageID,  pages: this.grouped_pages_total.items}]
        },
        total: function() {
            let t = 0
            if (this.grouped_pages_total.hasOwnProperty('meta')) {
                t = this.grouped_pages_total.meta.total_count;
            }  
            this.$emit('resultTotal', t);
            return t;
        }
    },
    watch: {
        filters: function() {
            if (localStorage.getItem('keep_page_number_on_first_filter')) {
                if (localStorage.getItem('keep_page_number_on_first_filter') == 'true') {
                    
                } else {
                    this.current_page = 1;
                }
            } else {
                this.current_page = 1;
            }
            localStorage.setItem('keep_page_number_on_first_filter', 'false');
        },
        current_page: function() {
            localStorage.setItem('current_page', this.current_page);
        }
    },
    created (){
        if (this.$route.meta.hasOwnProperty('fromHistory')) {
            if (this.$route.meta.fromHistory) {
                if (localStorage.getItem('current_page')) {
                    this.current_page = localStorage.getItem('current_page');
                }
            }
        }
        localStorage.setItem('current_page', this.current_page);
    },
    asyncComputed: {
        grouped_pages_total: {
            get() {
                let id = this.$route.meta.id;
                let axObject = axios.create()
                axObject.interceptors.request.use(config => {
                    this.loading_data = true;
                    return config;
                });
                axObject.interceptors.response.use(response => {
                    this.loading_data = false;
                    return response;
                });
                return axObject.get(this.data_url).then(response => {
                    return response.data;
                })
            },
            default: []
        }
    },
    methods: {
        testing() {
            console.log("This is after")
        },
        nextPage() {
            if (this.current_page < this.page_count) {
                this.current_page = this.current_page + 1;
                this.reverse = false;
            }
        },
        previousPage() {
            if (this.current_page > 1) {
                this.reverse = true;
                this.current_page = this.current_page - 1;
            }
        },
        getMoreInfo(id) {
            let tempItem = this.grouped_pages_total.items.find(item => item.id == id)
            if (tempItem.node_data.length > 0) {
                this.extraData.nodes = tempItem.node_data.slice(1)
            } else {
                this.extraData.nodes = []
            }
            
            this.extraData.name = tempItem.title
            this.extraData.address = tempItem.address
            this.extraData.phone_number = tempItem.phone_number
            this.extraData.other_links = tempItem.other_links
            this.extraData.website = tempItem.website
            this.extraData.description = tempItem.description
            this.$emit('moreInfo', this.extraData)
        },
        //// location of origin for arraysEqual, objectsEqual
        //// https://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript
        arraysEqual(a, b) {
            // if the other array is a falsy value, return
            if (!a){
                return false;
            }
            if (!b){
                return false;
            }

            // compare lengths - can save a lot of time 
            if (a.length != b.length)
                return false;

            for (var i = 0, l=a.length; i < l; i++) {
                // Check if we have nested arrays
                if (a[i] instanceof Array && b[i] instanceof Array) {
                    // recurse into the nested arrays
                    if (!this.arraysEqual(a[i], b[i])){
                        return false;
                    }
                } 
                else if (a[i] instanceof Object && b[i] instanceof Object) {
                    if (!this.objectsEqual(a[i], b[i])) {
                        return false;
                    }
                }
                else if (a[i] != b[i]) { 
                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
                    return false;   
                }           
            }       
            return true;
        },
        objectsEqual(a, b) {
            // console.log("This is A: ", a)
            // console.log("This is B: ", b)
            for (let propName in a) {
                //Check for inherited methods and properties - like .equals itself
                //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty
                //Return false if the return value is different
                if (a.hasOwnProperty(propName) != b.hasOwnProperty(propName)) {
                    return false;
                }
                //Check instance type
                else if (typeof a[propName] != typeof b[propName]) {
                    //Different types => not equal
                    return false;
                }
            }
            //Now a deeper check using other objects property names
            for(let propName in b) {
                //We must check instances anyway, there may be a property that only exists in object2
                    //I wonder, if remembering the checked values from the first loop would be faster or not 
                if (a.hasOwnProperty(propName) != b.hasOwnProperty(propName)) {
                    return false;
                }
                else if (typeof a[propName] != typeof b[propName]) {
                    return false;
                }
                //If the property is inherited, do not check any more (it must be equa if both objects inherit it)
                if(!a.hasOwnProperty(propName)) {
                    continue;
                }
                
                //Now the detail check and recursion
                
                //This returns the script back to the array comparing
                /**REQUIRES Array.equals**/
                if (a[propName] instanceof Array && b[propName] instanceof Array) {
                    // recurse into the nested arrays
                    if (!this.arraysEqual(a[propName], b[propName])) {
                        return false;
                    }
                }
                else if (a[propName] instanceof Object && b[propName] instanceof Object) {
                    // recurse into another objects
                    //console.log("Recursing to compare ", this[propName],"with",object2[propName], " both named \""+propName+"\"");
                    if (!this.objectsEqual(a[propName], b[propName])) {
                        return false;
                    }
                }
                //Normal value comparison for strings and numbers
                else if(a[propName] != b[propName]) {
                return false;
                }
            }
            //If everything passed, let's say YES
            return true;
        }
    }
}

</script>

<style scoped>
    /* p{
        margin-top: 0;
        font-weight: 500;
        font-size: 16px;
    } */

    button.thin {
        background: #fff;
        border: none;
        color: #3672a5;
        padding: 0;
        text-transform: initial;
        font-size: 1.25rem;
    }

     button.thin:hover {
        color: #333333;
    }

    .no-results {
        height: 0;
        margin: 0;
    }
    .column{
        position: relative;
    }

    .column img{
        display: block;
    }

    .subpage-item p{
        margin-bottom: .5rem;
        font-size: 1.35rem;
    }

    .subpage-item h3{
        margin-top: .5rem;
        font-size: 1.6rem;
        margin-bottom: .75rem;
    }

    .subpage-item{
        margin-bottom: 0;
        min-height: 190px;
    }

    /* .subpage-inner{ */
        /* padding: 2rem; */
        /* height: 100%; */
        /* min-height: 170px; */
        /* min-height: 260px;
        min-height: 400px; */
    /* } */

    #grouped-items{
        transition: all .75s;
        padding-top: 1rem;
        position: relative;
        /* min-height: 500px; */
    }

    .grouped-items-inner{
        position: relative;
        /* padding-bottom: 75px; */
    }

    #grouped-items .row{
        /* min-height: 50vh; */
    }


    .pagination{
        text-align: center;
    }

    .pagination p{
        display: inline-block;
        margin: 0 1.5rem;
    }

    .pagination.top{
        /* margin-bottom: 0rem; */
        margin-top: 3rem;
        /* position: absolute;
        bottom: 0;
        left: 0;
        right: 0; */
    }

    .pagination.bottom{
        margin-bottom: 3rem;
    }

    .pagination-image{
        min-height: 182px;
        display: block;
    }

    .subpage-item{
        /* transition: all .5s; */
    }

    .subpage-image{
        opacity: 0;
        transition: opacity .5s;
    }

    .subpage-image.loaded{
        opacity: 1;
    }

    .center-vert {
        vertical-align: middle;
    }

    /* .list-complete-move, #listy{ */
        /* transition: all .85s !important; */
        /* transition: all 2s; */
    /* } */

    #listy{
        width: 100%;
    }

    .subpage-item {
        /* transition: all 1s !important; */
        display: inline-block;
        margin-right: 10px;
    }
    .list-complete-enter, .list-complete-leave-to
    /* .list-complete-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: translateY(30px);
    }
    .list-complete-leave-active, .list-complete-enter-active {
        /* position: absolute; */
        /* transition: all .85s; */
        transition: all 2s;
    }

    .loader {
        border: 16px solid #f3f3f3; /* Light grey */
        border-top: 16px solid #3498db; /* Blue */
        border-bottom: 16px solid #3498db;
        border-radius: 50%;
        width: 120px;
        height: 120px;
        animation: spin 2s linear infinite;
        margin: auto;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }


.pagination .mobile-show{
    display: none;
    margin-bottom: 1rem;
}

@media (min-width: 768px){
    .pagination p{
      min-width: 24rem;
      margin: 2rem 3rem 0 3rem;
    }
}

@media (max-width: 500px){
    .pagination .mobile-show{
        display: block;
    }   

    .pagination .mobile-hide{
        display: none;
    } 

    .pagination .previous-page{
        margin-right: 4rem;
    }
}
</style>